// extracted by mini-css-extract-plugin
export default {"dateInput":"CustomEditorDateField-module__dateInput___JMMef"};